module.exports = "/assets/data/bbd76c164381ee2139e636bbf8c94dd2-LU7.data.json";